import CirclePlus from '../src/CirclePlus';
export default CirclePlus;
